import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

/**
 * Global footer — minimal premium cream/ink with neon accent on hover.
 *
 * Mobile note: BottomNav is a `fixed bottom-0` 80px bar on `< md`. The
 * footer adds its own bottom padding (matching `.pb-nav`) so its content
 * isn't covered by the bottom nav when scrolled to the page end.
 */
export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t-[2.5px] border-ink bg-paper text-ink mt-12 pb-[calc(6.5rem+env(safe-area-inset-bottom))] md:pb-0"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-8 md:py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-5">
        <div className="flex flex-col gap-1">
          <Link to="/" className="inline-flex items-center">
            <Logo heightClassName="h-6 md:h-7" testid="footer-logo" />
          </Link>
          <p className="text-[11px] uppercase tracking-widest text-ink/55">
            © {new Date().getFullYear()} inonit. Show up. Say hi.
          </p>
        </div>

        <nav className="flex flex-wrap items-center gap-2 md:gap-3" aria-label="Footer">
          <FooterLink to="/terms"    testid="footer-terms">Terms &amp; conditions</FooterLink>
          <FooterLink to="/privacy"  testid="footer-privacy">Privacy policy</FooterLink>
          <FooterLink to="/settings" testid="footer-feedback">Feedback &amp; suggestions</FooterLink>
        </nav>
      </div>
    </footer>
  );
}

function FooterLink({ to, testid, children }) {
  return (
    <Link
      to={to}
      data-testid={testid}
      className="text-[11px] uppercase tracking-[0.2em] font-extrabold px-3 py-2 rounded-full border-[2.5px] border-ink bg-paper hover:bg-neon transition-colors"
    >
      {children}
    </Link>
  );
}
